import React, { useState, useContext, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import Assignee from "components/sales/formSection/assignee/assignee";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import Commercial from "components/sales/formSection/commercial/commercial";
import { documentUploadUrl } from "../../../services/redux/fileUpload/action";
import FormSection from "../../../components/sales/formSection/formSectionNew";
import DropDownInput from "../../../components/sales/Input/dropDownInput/dropDownInput";
import AgreementContract from "../../../components/sales/formSection/agreementContract/agreementContract";
import DivLayout from "../../../components/sales/divLayout/divLayout";
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import Milestone from "../../../components/sales/formSection/mileStone/mileStone";
import { toast } from "react-toastify";
import { renewalSaveEditData } from "../../../services/redux/brandActivtion/sitesListing/action";
import InvoiceModuleRenew from "components/sales/formSection/materialHardware/invoiceModuleRenew";
import { handleValidateObj } from "constants/objValues/objvalues";
import Increament from "components/sales/formSection/materialHardware/increament";
import ConstantInput from "components/sales/Input/constantInput/constantInput";

const EditRenewContract = ({
  documentUploadUrl,
  documentUrlData,
  getContractDataForRenewal,
  contractData,
  match,
  renewalSaveEditData,
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const [contractId, setContractId] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isRequired, setRequired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [products, setProducts] = useState([]);
  const postDataInputs = {
    commercial: null,
    agreementDtls: null,
    invoiceModuleData: null,
  };
  const inputs = {
    assigneeDetail: null,
  };
  const [assigneeData, setAssigneeData] = useState(inputs);
  const [postCorporateData, setPostCorporateData] = useState(postDataInputs);
  const [showAgreementDetails, setShowAgreementDetails] = useState(false);
  const [agreementLength, setAgreementLength] = useState(null);
  const [existingPostsaleData, setExistingPostsaleData] = useState(null);
  const [commercialData, setCommercialData] = useState({
    commercialData: null,
  });
  const [incrementData, setIncrementData] = useState({
    increment_type: null,
    duration: null,
    increament_amount: null,
    inc: null,
  });
  const [contractPriceToEndClient, setContractPriceToEndClient] =
    useState(null);

  useEffect(() => {
    setContractId(match.params.contractId);
    (async () => {
      if (contractId) {
        setIsLoading(true);
        await getContractDataForRenewal(contractId, true);
        setIsLoading(false);
      }
    })();
  }, [contractId]);

  useEffect(() => {
    if (contractData && contractData?.products) {
      setProducts(contractData?.products);
    }

    if (
      contractData &&
      contractData?.commercials &&
      contractData?.commercials?.postsale_data
    ) {
      setExistingPostsaleData(contractData?.commercials?.postsale_data);
    }

    // Initialize contractPriceToEndClient with the autofilled value
    if (
      contractData?.contractData?.postsale_data?.commercial
        ?.cp_price
    ) {
      setContractPriceToEndClient(
        contractData?.contractData?.postsale_data?.commercial
          ?.cp_price
      );
    }
    if (contractData?.contractData?.postsale_data) {
      const incData = contractData?.contractData?.postsale_data?.inc.map(
        (item) => ({
          subscription_amount: item.subscription_amount,
        })
      );
      setIncrementData({
        ...incrementData,
        increment_type:
          contractData?.contractData?.postsale_data?.increment_type ?? null,
        duration: contractData?.contractData?.postsale_data?.duration ?? null,
        increament_amount:
          contractData?.contractData?.postsale_data?.increament_amount ?? null,
        inc: incData ?? null,
      });
    }
  }, [contractData]);

  const handleAssignee = (val) => {
    setAssigneeData({ ...assigneeData, assigneeDetail: val });
  };
  const handleCommercial = (val) => {
    setPostCorporateData({ ...postCorporateData, commercial: val });
    if (val?.totalContract) {
      setShowAgreementDetails(true);
      setAgreementLength(val?.totalContract);
      setCommercialData({
        ...commercialData,
        commercialData: {
          contract_length: val?.totalContract,
          subscription_amount: val?.subAmt,
          payment_term_type: val?.paymentTerms,
          commercial_type_id: val?.commercialType,
        },
      });
    }
  };
  const handleagreementDtls = (val) => {
    setPostCorporateData({ ...postCorporateData, agreementDtls: val });
  };
  const handleMileStone = (val) => {
    setPostCorporateData({ ...postCorporateData, milestone: val });
  };
  const handleInvoiceAmt = (val) => {
    setPostCorporateData({ ...postCorporateData, invoiceModuleData: val });
  };
  const handleIncreament = (val) => {
    setPostCorporateData({ ...postCorporateData, increamentData: val });
  };
  const handleModalHide = () => setIsModal(false);

  const handleSubmit = () => {
    const {
      commercial,
      agreementDtls,
      milestone,
      invoiceModuleData,
      increamentData,
    } = postCorporateData;
    if (commercial == null || agreementDtls == null) {
      setIsFiled(true);
      setIsModal(false);
      const active = document.querySelector(".activeAnkInput");
      if (active) {
        active.focus();
      } else {
        alert("Please Upload missed documents !");
      }
      return false;
    } else {
      var fObj = {
        ...commercial,
        ...agreementDtls,
        invoiceModuleData,
      };
      let increamentDatas = [];
      if (commercial.commercialType == 7) {
        if (increamentData !== null && increamentData !== undefined) {
          if (increamentData?.inc?.increament_type) {
            if (
              increamentData?.inc?.increament_type == "flat" ||
              increamentData?.inc?.increament_type == "percentage"
            ) {
              if (
                increamentData?.inc?.duration == undefined ||
                increamentData?.inc?.duration == "" ||
                increamentData?.inc?.increament_amount == undefined ||
                increamentData?.inc?.increament_amount == ""
              ) {
                toast.error("Please fill the increment Duration and amount");
                return false;
              }
            }
            increamentDatas = increamentData;
          } else {
            toast.error("Please Select increment type");
            return false;
          }
        }
      }
      fObj.increamentDatas = increamentDatas;
      if (milestone !== null && milestone != undefined) {
        let calculatedAmt = 0;
        for (
          let i = 0;
          i < postCorporateData.milestone?.date_invoices_data.length;
          i++
        ) {
          if (postCorporateData.milestone.date_invoices_data[i].amt) {
            calculatedAmt += parseInt(
              postCorporateData.milestone.date_invoices_data[i].amt
            );
          }
        }
        if (commercial.totalAmount != calculatedAmt) {
          toast.error("Milestone total amount is not equal to capex amount!");
          return;
        } else {
          fObj.milestone = milestone;
        }
      }

      var isStop = false;
      if (invoiceModuleData !== null && invoiceModuleData != undefined) {
        invoiceModuleData.invoiceData.map((val, index) => {
          if (!handleValidateObj(val)) {
            isStop = true;
          }
        });
      }
      if (isStop) {
        toast.error("Please fill all invoice details.");
        return false;
      }

      fObj.comm_id = match.params.contractId;
      fObj.cp_price = contractPriceToEndClient;
      setIsFiled(false);
      setIsLoading(true);
      (async () => {
        const res = await renewalSaveEditData(fObj);
        if (res) {
          setIsModal(true);
        }
        setIsLoading(false);
      })();
    }
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.renewContract}
      Buttons={headerBtns}
      className={isFiled ? "requiredFileds" : ""}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      {/*<Fragment>
        <FormSection title={localization.commercialType}>
          <DropDownInput
              data={commercialTypes}
              label={localization.commercialType}
              required
              isStarRequired={true}
              errorMsg={localization.requiredcommercialType}
              getIdValue={(val) => handleIdvalue(val)}
              value={commercialData.commercialPrefilled.value}
              disabled = {edit == 1 ?true:false}
          />
        </FormSection>
      </Fragment>*/}
      {/*<Assignee
        assigneeList={assigneeList}
        siteId={siteId}
        handleValue={handleAssignee}
        isBulkAssignment={true}
        baAssignee={true}
      />*/}
      {contractData && (
        <>
          <Commercial
            data={contractData}
            handleValue={handleCommercial}
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            prefilledData={contractData?.contractData?.postsale_data}
            isRenewal={true}
            // edit={1}
          />

          {(contractData &&
            contractData?.contractData &&
            contractData?.contractData &&
            contractData?.contractData?.postsale_data &&
            contractData?.contractData?.postsale_data?.commercial &&
            contractData?.contractData?.postsale_data?.commercial?.channel_partner_id &&
            contractData?.contractData?.postsale_data?.commercial?.channel_partner_id !==
              null) && (
              <>
                <FormSection title={"Contract Price to end client"}>
                  <div className="col-md-12">
                    <ConstantInput
                      label={"Contract Price to end client"}
                      required
                      isStarRequired={true}
                      errorMsg={"Contract Price to end client is required"}
                      type="number"
                      handleChange={(val) => setContractPriceToEndClient(val)}
                      value={contractPriceToEndClient}
                    />
                  </div>
                </FormSection>
              </>
            )}
          {(contractData.commericals?.postsale_data?.commercial
            ?.revenue_nature !== "Valet" ||
            contractData.commericals?.postsale_data?.commercial
              ?.revenue_nature !== "Services") &&
            (postCorporateData.commercial?.commercialType === 7 ||
              postCorporateData.commercial?.commercialType === 6) && (
              <>
                <Increament
                  handleValue={handleIncreament}
                  data={commercialData}
                  // imageUploadUrl={imageUploadUrl}
                  prefilledData={incrementData}
                />
              </>
            )}
          <AgreementContract
            handleValue={handleagreementDtls}
            documentUploadUrl={documentUploadUrl}
            agreementLength={agreementLength}
            showDetails={showAgreementDetails}
            prefilledData={contractData?.contractData?.postsale_data}
            isEditContract={true}
          />
          {postCorporateData.commercial?.commercialType === 5 && (
            <Milestone handleValue={handleMileStone} isRenewal={true} />
          )}
          {postCorporateData.commercial?.commercialType === 7 && (
            <InvoiceModuleRenew
              handleValue={handleInvoiceAmt}
              data={postDataInputs}
              prefilledData={contractData?.contractData?.postsale_data}
              invoiceAmtData={contractData?.contractData?.postsale_data}
              isdisable={false}
              productData={products}
            />
          )}
        </>
      )}

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.contractUpdate}</h5>
          <Link
            to={`${baseUrl}/brand-activation/sites-listing`}
            className="btn btn-primary mb-4"
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

EditRenewContract.propTypes = {};

export default EditRenewContract;
